<div class="qr-page" data-cy="qr-external-buildings">

  <header class="qr-header">
    <span class="qr-header-title">Gebäude</span>
    @if (session(); as current) {
      <span class="qr-header-sub" data-cy="qr-external-session">{{ current.userName }} · {{ current.tenantName }}</span>
    }
  </header>

  <input nbInput fullWidth type="search" placeholder="Gebäude suchen"
         data-cy="qr-external-building-search"
         [value]="search()" (input)="search.set($any($event.target).value)">

  <div class="building-list" [nbSpinner]="loading()">
    @for (building of filteredBuildings(); track building.id) {
      <button class="building-item" data-cy="qr-external-building" (click)="openBuilding(building)">
        <div class="building-info">
          <span class="building-name">{{ building.name }}</span>
          @if (building.sectionText) {
            <span class="building-address">{{ building.sectionText }}</span>
          }
        </div>
        @if (building.scanned) {
          <span class="scanned-tag" data-cy="qr-external-scanned">Gescannt</span>
        }
        <nb-icon icon="arrow-ios-forward-outline" pack="eva" class="chevron"></nb-icon>
      </button>
    } @empty {
      @if (!loading()) {
        <div class="empty-state">
          <nb-icon icon="home-outline" pack="eva"></nb-icon>
          <p>Keine Gebäude gefunden</p>
        </div>
      }
    }
  </div>

</div>
